export default __webpack_public_path__ + "static/eu-parliament-logo-667605e640d798d642b3c0bc1749e805.svg";